import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

const WhatsAppLink = ({ children }) => {
  const { t } = useTranslation();
  const phone = t('panel.avisos.alert.lockedSoft.phone');

  return (
    <a
      href={`https://wa.me/${phone}`}
      target='_blank'
      rel='noopener noreferrer'
      style={{ color: 'inherit', textDecoration: 'underline' }}
    >
      {children}
    </a>
  );
};

const PHONE_KEY = 'panel.avisos.alert.lockedSoft.phone';

const LockedSoftAlertMessage = ({ messageKey = 'panel.avisos.alert.lockedSoft' }) => {
  const { t } = useTranslation();
  const phone = t(PHONE_KEY);
  const hasWhatsAppContact = phone && phone !== PHONE_KEY;

  if (!hasWhatsAppContact) {
    return t(messageKey);
  }

  return <Trans i18nKey={messageKey} values={{ phone }} components={{ 1: <WhatsAppLink /> }} />;
};

export default LockedSoftAlertMessage;
